// extracted by mini-css-extract-plugin
export var colorSquare = "_qw-0";
export var danger = "_qw-5";
export var lightPink = "_qw-8";
export var neutralBlue = "_qw-7";
export var neutralYellow = "_qw-6";
export var normal = "_qw-1";
export var primary = "_qw-2";
export var primaryLight = "_qw-3";
export var solidBlack = "_qw-g";
export var solidGreen = "_qw-b";
export var solidLightBlue = "_qw-d";
export var solidNavy = "_qw-c";
export var solidOrange = "_qw-f";
export var solidPink = "_qw-e";
export var solidRed = "_qw-9";
export var solidYellow = "_qw-a";
export var success = "_qw-4";